import {AxiosInstance} from "axios";
import {createOne, deleteOne, queryPage, updateOne} from "../../../shared/technical/rest/restApi";
import {ApplicationUserGroup, ApplicationUserGroupMembership, CreateApplicationUserGroupMembership} from "./ApplicationUserGroup";
import {fullPageable, PagedResult} from "../../../shared/technical/rest/pageable";

export function getAllApplicationUserGroups(axios: AxiosInstance, applicationId: string | number): Promise<ApplicationUserGroup[]> {
  return queryPage<ApplicationUserGroup>(axios, "applications/" + applicationId + "/user-groups", fullPageable())
    .then((page: PagedResult<ApplicationUserGroup>) => page.content)
}

export function createApplicationUserGroup(axios: AxiosInstance, applicationId: string | number, applicationUserGroup: ApplicationUserGroup): Promise<ApplicationUserGroup> {
  return createOne(axios, "applications/" + applicationId + "/user-groups", applicationUserGroup)
}

export function updateApplicationUserGroup(axios: AxiosInstance, applicationId: string | number, applicationUserGroup: ApplicationUserGroup): Promise<ApplicationUserGroup> {
  return updateOne(axios, "applications/" + applicationId + "/user-groups", applicationUserGroup)
}

export function deleteApplicationUserGroup(axios: AxiosInstance, applicationId: string | number, applicationUserGroupId: string | number): Promise<void> {
  return deleteOne(axios, "applications/" + applicationId + "/user-groups", applicationUserGroupId)
}

export function getAllApplicationUserGroupMembers(
  axios: AxiosInstance,
  applicationId: string | number,
  applicationUserGroupId: string | number
): Promise<ApplicationUserGroupMembership[]> {
  return queryPage<ApplicationUserGroupMembership>(axios, "applications/" + applicationId + "/user-groups/" + applicationUserGroupId + "/members", fullPageable())
    .then((page: PagedResult<ApplicationUserGroupMembership>) => page.content)
}

export function addMemberToApplicationUserGroup(
  axios: AxiosInstance,
  applicationId: string | number,
  applicationUserGroupId: string | number,
  membership: CreateApplicationUserGroupMembership
): Promise<ApplicationUserGroupMembership> {
  return createOne(axios, "applications/" + applicationId + "/user-groups/" + applicationUserGroupId + "/members", membership)
}

export function deleteMemberOfApplicationUserGroup(
  axios: AxiosInstance,
  applicationId: string | number,
  applicationUserGroupId: string | number,
  membershipId: string | number
): Promise<void> {
  return deleteOne(axios, "applications/" + applicationId + "/user-groups/" + applicationUserGroupId + "/members", membershipId)
}
